<div style="width: 40%; float:left">
  @if (errorVisible) {
  <div class="dx-card">
    <div class="textarea-wrapper">
      <dx-text-area [(value)]="errorMessage"
                    [autoResizeEnabled]="true"
                    [inputAttr]="{ 'aria-label': 'Notes' }">
      </dx-text-area>
    </div>
  </div>
  }
  <div class="dx-card">
    <dx-data-grid [dataSource]="clocksDataSource"
                  [showBorders]="true"
                  [showColumnHeaders]="false"
                  [columnAutoWidth]="true">
      <dxo-group-panel [visible]="false"></dxo-group-panel>

      <dxi-column dataField="linkType"
                  [groupIndex]="0"
                  groupCellTemplate="groupCellTemplate">
        <dxo-lookup [dataSource]="lookupData"
                    valueExpr="id"
                    displayExpr="name">
        </dxo-lookup>
      </dxi-column>
      <dxi-column dataField="deviceDate" dataType="datetime" caption="Data"></dxi-column>
      <dxi-column dataField="direction" dataType="string"></dxi-column>
      <dxi-column dataField="distanzaCantiereInMetri" dataType="number">
        <dxo-format type="fixedPoint"
                    [precision]="0">
        </dxo-format>
      </dxi-column>
      <dxi-column type="buttons">
        <dxi-button text="Apri"
                    icon="globe"
                    hint="Apri su Google Maps"
                    [onClick]="apriMaps">
        </dxi-button>
      </dxi-column>
      <div *dxTemplate="let data of 'groupCellTemplate'">
        <div>{{data.displayValue}}</div>
      </div>
    </dx-data-grid>
  </div>
</div>

<div style="width: 60%; float:right">
  @if (mapVisible) {
  <app-clock-map [markers]="mapMarkers"></app-clock-map>
  }
</div>
